module.exports = __webpack_public_path__ + "static/media/first_1.27a4f122.jpg";